// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3IoSs","selected":"Chip_selected__2lZsI"};